import PDF from "../website-behaviors/PDF.js";

class ProQuestPrint extends PDF {
	identifier() {
		return "ProQuestPrint";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return location.host === "ebookcentral.proquest.com"
			&& location.pathname.match(/\/printPage\.action/);
	}

	isPDFDownloadable() {
		return true;
	}
}

export default ProQuestPrint;
